import { buildProps, definePropType } from '@bigin/utils'
import { popperTriggerProps } from '@bigin/components/popper'
import { EVENT_CODE } from '@bigin/constants'
import type { Arrayable } from '@bigin/utils'
import type { ExtractPropTypes } from 'vue'

export type TooltipTriggerType = 'hover' | 'focus' | 'click' | 'contextmenu'

export const useTooltipTriggerProps = buildProps({
  ...popperTriggerProps,
  disabled: Boolean,
  trigger: {
    type: definePropType<Arrayable<TooltipTriggerType>>([String, Array]),
    default: 'hover',
  },
  triggerKeys: {
    type: definePropType<string[]>(Array),
    default: () => [EVENT_CODE.enter, EVENT_CODE.space],
  },
} as const)

export type BTooltipTriggerProps = ExtractPropTypes<
  typeof useTooltipTriggerProps
>
